import { z } from 'zod'
import typeguard from '../typeguard'
import { cartPriceLockSchema, discountSchema, productCouponPromotionSchema } from './product'
import { productPurchaseModeSchema } from '../productPurchaseMode'

export const productCommercePreviewSchema = z.object({
  id: z.number(),
  brand: z.number().optional(),
  brandTitel: z.string().optional(),
  categorie: z.number().optional(),
  key: z.string(),
  hash: z.string().optional(),
  price: z.number(),
  deliverytime: z.number(),
  stockDeliverytime: z.number().optional(),
  stock: z.number().optional(),
  shippingType: z.number(),
  discount: discountSchema.optional(),
  couponPromotion: productCouponPromotionSchema.nullable().optional(),
  priceLock: cartPriceLockSchema.optional(),
  purchaseMode: productPurchaseModeSchema.optional(),
  inquireOnly: z.literal(true).optional(),
})

export type tProductCommercePreview = z.infer<typeof productCommercePreviewSchema>

export const productCommercePreviewsSchema = z.array(productCommercePreviewSchema)
export type tProductCommercePreviews = z.infer<typeof productCommercePreviewsSchema>
export const isProductCommercePreviews = typeguard<tProductCommercePreviews>(productCommercePreviewsSchema)
